(function (Drupal, once) {
  Drupal.behaviors.globalHeaderHide = {
    attach: function (context) {
      once('global-header-hide', '.global-header-fixed', context).forEach(function (header) {
        var wrapper = document.querySelector('.global-header');
        var lastScrollTop = 0;
        var delta = 5;
        var ticking = false;

        // Reserve space equal to the header's height so DOM doesn't jump
        function setHeaderHeight() {
          wrapper.style.height = header.offsetHeight + 'px';
        }
        setHeaderHeight();
        window.addEventListener('resize', setHeaderHeight);

        function updateHeader(scrollTop) {
          // Don't tuck (hide) or scroll the header if the menu is expanded
          var globalHeader = document.querySelector('.global-header');
          var isMenuOpen = globalHeader && globalHeader.querySelector('.show');

          if (isMenuOpen) {
            header.classList.remove('tucked');
            lastScrollTop = scrollTop;
            ticking = false;
            return;
          }

          if (scrollTop <= 0) {
            header.classList.remove('tucked');
          } else if (scrollTop > lastScrollTop && scrollTop > header.offsetHeight) {
            header.classList.add('tucked');
          } else if (scrollTop + window.innerHeight < document.body.scrollHeight) {
            header.classList.remove('tucked');
          }
          lastScrollTop = scrollTop;
          ticking = false;
        }

        window.addEventListener('scroll', function () {
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

          if (!ticking && Math.abs(lastScrollTop - scrollTop) > delta) {
            ticking = true;
            window.requestAnimationFrame(function () {
              updateHeader(scrollTop);
            });
          }
        });
      });
    }
  };
})(Drupal, once);
